"use strict";

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Skeleton = _interopRequireDefault(require("../../Skeleton"));

var _Text = _interopRequireDefault(require("../../Text"));

var _SubSection = _interopRequireDefault(require("./SubSection"));

var _useIsLoading = _interopRequireDefault(require("../LoadingProvider/useIsLoading"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Profile = function Profile(props) {
  var _props$profile = props.profile,
      profile = _props$profile === void 0 ? '' : _props$profile,
      other = (0, _objectWithoutProperties2["default"])(props, ["profile"]);
  var t = (0, _useTranslation["default"])();
  var isLoading = (0, _useIsLoading["default"])();
  var Content = (0, _react.useCallback)(function () {
    if (isLoading) {
      return (0, _core.jsx)(_react["default"].Fragment, null, (0, _core.jsx)(_Text["default"], {
        as: "span",
        gutter: 2
      }, (0, _core.jsx)(_Skeleton["default"], {
        width: "85%"
      })), (0, _core.jsx)(_Text["default"], {
        as: "span",
        gutter: 2
      }, (0, _core.jsx)(_Skeleton["default"], {
        width: "30%"
      })), (0, _core.jsx)(_Text["default"], {
        as: "span"
      }, (0, _core.jsx)(_Skeleton["default"], {
        width: "40%"
      })));
    }

    var children = profile.split('\n').map(function (trait, index, arr) {
      var hideGutter = index === arr.length - 1;
      return (0, _core.jsx)(_Text["default"], {
        key: index,
        "data-testid": "Trait",
        as: "span",
        variant: "paragraph",
        gutter: hideGutter ? 0 : 1.5
      }, trait);
    });
    return (0, _core.jsx)(_react["default"].Fragment, null, children);
  }, [profile, isLoading]);

  if (!profile && !isLoading) {
    return null;
  }

  return (0, _core.jsx)(_SubSection["default"], (0, _extends2["default"])({
    title: t('requested_profile')
  }, other), (0, _core.jsx)(Content, null));
};

__signature__(Profile, "useTranslation{t}\nuseIsLoading{isLoading}\nuseCallback{Content}", function () {
  return [_useTranslation["default"], _useIsLoading["default"]];
});

var _default = Profile;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Profile, "Profile", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Description/Profile.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Description/Profile.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();